import { render, staticRenderFns } from "./TermManage.vue?vue&type=template&id=39fd6ee2&scoped=true"
import script from "./TermManage.vue?vue&type=script&lang=js"
export * from "./TermManage.vue?vue&type=script&lang=js"
import style0 from "./TermManage.vue?vue&type=style&index=0&id=39fd6ee2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fd6ee2",
  null
  
)

export default component.exports